import { useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Card,
  Drawer,
  Toolbar,
  Typography,
  Container,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import AppIcon from "@/assets/app-icon.svg";
import CurrentUserDrawer from "@/components/CurrentUserDrawer";
import ArtistLogo from "@/fragments/ArtistLogo";
import NotebookIcon from "@/fragments/NotebookIcon";
import { useActiveArtists } from "@/services/hooks";
import { useParams, useNavigate } from "react-router-dom";

export default function MainAppBar({ showUserDrawer = true }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { artistKey } = useParams();
  const switchable = false; // hardcode off for now

  const handleClick = () => {
    if (switchable) {
      setOpen(true);
    } else if (artistKey) {
      navigate(`/${artistKey}`);
    } else {
      navigate("/");
    }
  };

  return (
    <Box sx={{ mb: 8 }}>
      <AppBar
        position="fixed"
        elevation={0}
        style={{ background: "rgba(19,19,19,.9)" }}
      >
        <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
          <Box
            onClick={handleClick}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <ArtistLogo />
            {switchable && <ExpandMore sx={{ ml: 0.5, opacity: 0.9 }} />}
          </Box>

          {showUserDrawer && <CurrentUserDrawer />}
        </Toolbar>
      </AppBar>
      <MenuDrawer open={open} setOpen={setOpen} />
    </Box>
  );
}

function MenuDrawer({ open, setOpen }) {
  const { data: artists } = useActiveArtists();
  const navigate = useNavigate();

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        style: { borderRadius: "10px 10px 0 0" },
      }}
      elevation={10}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            py: 4,
            maxHeight: "80vh",
            overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/")}
            sx={{ borderRadius: "20px", my: 2, opacity: 0.8 }}
            fullWidth
          >
            Home
          </Button>
          <Box id="artists-gallery">
            {/* {currentUser.role === "artist" && <ArtistCard artist={currentUser} />} */}
            {artists?.map((artist, index) => (
              <ArtistCard artist={artist} key={index} setOpen={setOpen} />
            ))}
          </Box>
        </Box>
      </Container>
    </Drawer>
  );
}

function ArtistCard({ artist, setOpen }) {
  const { artistKey } = useParams();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${artist.key}`);
    setOpen(false);
  };

  return (
    <Card
      key={artist.key}
      sx={{
        display: "flex",
        width: "100%",
        my: 1,
        height: "60px",
        borderRadius: "10px",
      }}
      onClick={handleClick}
    >
      <Box>
        <img
          src={artist.meta?.profile || AppIcon}
          onClick={() => setOpen(true)}
          style={{ width: "60px", height: "60px", objectFit: "cover" }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          pl: 2,
          pr: 4,
        }}
      >
        <Typography variant="h7" sx={{ fontWeight: 600 }}>
          {artist.name || artist.key}
        </Typography>
        {artist.key === artistKey && <NotebookIcon size={24} />}
      </Box>
    </Card>
  );
}
